<!-- <div class="back-container">
   <div class="back" routerLink="/login">
        <frg-inline-svg stroke="var(--primary)" class="back-icon" src="assets/icons/chevron-left.svg"></frg-inline-svg>
        <div class="back-text">Connexion</div>
    </div>
</div> -->

<!-- Formulaire de connexion initial -->
<form [formGroup]="loginForm" class="login-card-content" (ngSubmit)="onSubmit()" *ngIf="currentStep === LoginStepEnum.INITIAL">

    <div class="buttons-container">
        <div class="pscconnect-button-container">
            <img src="assets/images/psc_identification.png" (click)="pscLogin()" class="pscconnect-button" />
        </div>
    </div>

    <div class="separator-wrapper">
        <div class="separator"></div>
    </div>

    <div class="buttons-container">
        <div class="connect-button-container">
            <button type="button" (click)="cpsLogin()" class="button cps-login">
                Se connecter avec une carte CPS/CPE
            </button>
        </div>
    </div>

    <div class="separator-wrapper">
        <div class="separator"></div>
    </div>

    <div class="account-list-container" [ngClass]="{'hidden': (!localAuths || localAuths.length === 0)}">
        <div class="account-list-title">Liste des comptes</div>
        <div class="account-list-search-container">
            <div class="search-container">
                <div class="search-input">
                    <frg-search-input (search)="search = $event"></frg-search-input>
                </div>
            </div>
            <div class="account-list" [ngClass]="{'hidden': loading}">
                <div class="account" *ngFor="let account of localAuths | search: search: 'account'">
                    <!-- Admin don't have profils -->
                    <label *ngIf="!account.profil" class="label" [for]="account.utilisateur.email">{{account.utilisateur.pseudo}}
                        <input *ngIf="!account.profil" [id]="account.utilisateur.email" type="radio"
                            [value]="account" (ngModelChange)='fillEmail(account)' formControlName="accountSelected" />
                    </label>
                    <!-- Users have mutliple profils with the same email -->
                    <label *ngIf="account.profil" class="label" [for]="account.profil.id">{{account.utilisateur.pseudo}}
                        <span *ngIf="account.profil.cabinet">({{account.profil.cabinet.nom}})</span>
                        <input *ngIf="account.profil.id" [id]="account.profil.id" type="radio"
                            [value]="account" (ngModelChange)='fillEmail(account)' formControlName="accountSelected" />
                    </label>
                </div>
                <div class="no-element" *ngIf="(localAuths | search: search: 'account').length === 0">
                    Aucun élément ne correspond à votre recherche
                </div>
            </div>
            <div class="lds-spinner-container" [ngClass]="{'hidden': !loading}">
                <div class="lds-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>

    <div class="inputs-container">
        <frg-form-input placeholder="exemple@gmail.com" label="Adresse email" id="login"
            errorMessage="Veuillez entrer une adresse email valide" type="text" [formGroup]="loginForm"
            [control]="loginForm.get('login')" (modelChanged)="uncheckRadio()" required="true"></frg-form-input>
        <frg-form-input placeholder="Mot de passe" label="Mot de passe" id="password"
            errorMessage="Veuillez entrer votre mot de passe" type="password" [formGroup]="loginForm"
            [control]="loginForm.get('password')" required="true"></frg-form-input>
        <div class="captcha-container">
          <re-captcha (resolved)="resolved($event)" [siteKey]="recaptchaSiteKey"></re-captcha>
        </div>
        <div class="forget-password">
            <span routerLink="forgot-password">Mot de passe oublié ?</span>
        </div>
    </div>
    <div class="buttons-container mail-login-container">
        <div class="connect-button-container">
            <button type="submit" class="button mail-login">
                Se connecter
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
    </div>
    <div class="error-container login-error" [ngClass]="{'no-height': !errorLogin}">
        Identifiants incorrects
    </div>
</form>

<!-- Formulaire de vérification OTP -->
<form [formGroup]="otpForm" class="login-card-content otp-form" (ngSubmit)="onOtpSubmit()" *ngIf="currentStep === LoginStepEnum.OTP_REQUESTED">
    <div class="otp-header">
        <h2>Vérification OTP</h2>
        <p>Un code de vérification a été envoyé sur la boîte mail utilisé pour la connexion. Veuillez le saisir ci-dessous.</p>
        <div class="otp-info" *ngIf="otpSession">
            <p>{{otpSession.message}}</p>
            <div class="otp-timer" *ngIf="otpTimeRemaining > 0 && !otpExpired">
                Temps restant : {{getOtpTimeFormatted()}}
            </div>
            <div class="otp-expired-message" *ngIf="otpExpired">
                Code expiré. Veuillez demander un nouveau code.
            </div>
            <div class="otp-attempts" *ngIf="otpSession.attemptsRemaining != null">
                Tentatives restantes : {{otpSession.attemptsRemaining}}
            </div>
        </div>
    </div>
    <div class="otp-disable" *ngIf="otpSession.attemptsRemaining === 0">
        Trop de tentatives echouées code OTP bloqué. Veuillez cliquer sur retour à la connexion pour recommencer.
    </div>
    <div class="inputs-container" *ngIf="otpSession.attemptsRemaining > 0 && !otpExpired">
        <frg-form-input placeholder="123456" label="Code OTP (6 chiffres)" id="otpCode"
            errorMessage="Veuillez entrer un code OTP valide (6 chiffres)" type="text" [formGroup]="otpForm"
            [control]="otpForm.get('otpCode')" required="true" maxlength="6"></frg-form-input>
    </div>

    <div class="buttons-container otp-buttons-container">
        <div class="connect-button-container" *ngIf="otpSession.attemptsRemaining > 0 && !otpExpired">
            <button type="submit" class="button otp-verify" [disabled]="!otpForm.valid || otpExpired || otpSession.attemptsRemaining === 0" >
                Vérifier le code
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
        <div class="secondary-actions">
            <button type="button" class="button secondary" (click)="resendOtp()" *ngIf="otpSession.attemptsRemaining > 0 && otpCooldownRemaining === 0" >
                Renvoyer un code
            </button>
            <button type="button" class="button secondary" (click)="backToLogin()">
                Retour à la connexion
            </button>
        </div>
    </div>

    <div class="error-container otp-error" [ngClass]="{'no-height': !errorOtp}">
        Code OTP incorrect ou expiré
    </div>

</form>
